<template>
    <GenComponent></GenComponent>
</template>

<script>
import GenComponent from "@/components/GenComponent";

export default {
    name: 'App',
    components: {GenComponent},

}
</script>

<style>
label {
    font-weight:bold;
}
html {
    font-size: 90%;
}
.ib {
    display:inline-block;
    margin-right: 1rem;
}
</style>